import {getRestfulData} from "./Common";

export async function getPosCustomers({page}){
    return getRestfulData({
        url: `common/sale-customer?p=${page}`
    });
}